export default __webpack_public_path__ + "static/media/react.6495a7f1.png";